module.exports = __webpack_public_path__ + "static/img/moniqi.a9e55590.png";